import { render, staticRenderFns } from "./resumeDetails.vue?vue&type=template&id=472c0ee5&scoped=true&"
import script from "./resumeDetails.vue?vue&type=script&lang=js&"
export * from "./resumeDetails.vue?vue&type=script&lang=js&"
import style0 from "./resumeDetails.vue?vue&type=style&index=0&id=472c0ee5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c0ee5",
  null
  
)

export default component.exports